import * as angular from 'angular';

import { ZoomService } from './zoom.service';

export const zoomServiceModule = angular.module('zoomService', [])
	.service('zoomService', ZoomService)
	.name;
